(function () {
   'use strict';
   //var logger = new (require('../helpers/logger.js'))("Overlay").setColor("DimGray");
   var helper = require('../helpers/generic.js');
   require('../styles/Overlay/main.less');
   var jQuery = require("jquery");
   require("jquery.browser"); //add jQuery.browser for jQuery versions newer than v1.8
   require('jqOverlay');
   require('jqExpose');


   module.exports = Overlay;

   var defaultOptions = {
     dom: {
       id: "cmy-overlay",
       class: "cmy-overlay",
       moreClasses: "",
       parentSelector: "body",
       closeButtonClass: "btn-close btn-close-overlay",
       showClose: true,
       fixed: true,
       closeOnClick: true
     },
     mask: {
       color: '#000000',
       loadSpeed: 800,
       opacity: 0.7
     }
   };

   function Overlay(content, options, removalCallback){
     this.setContent(typeof content=="undefined" ? null : content);
     this.options = jQuery.extend(true, {}, defaultOptions);
     this.modifyOptionsWith(options);
     this.removalCallbacks = [];
     if (typeof removalCallback!="undefined" && removalCallback !== null){
       this.addRemovalCallback(removalCallback);
     }
     this.enableAutoCenter();
   }

   Overlay.prototype = {
     /*********************
      * 'PRIVATE' Methods *
      *********************/
     _getGeneratedDom: function _getGeneratedDom(){
       var content = this.content === null ? jQuery("<span></span>") : this.content;
       var $main = jQuery("<div class='"+this.options.dom.class+" "+this.options.dom.moreClasses+"' id='"+this.options.dom.id+"'></div>");
       if (!helper.undefOrNull(content)){
         $main.append(content);
       }
       if (this.options.dom.showClose){
         var overlayId = this.options.dom.id;
         var $close = jQuery("<a class='"+this.options.dom.closeButtonClass+"-wrapper cmy-close'><div class='"+this.options.dom.closeButtonClass+"' id='close-"+overlayId+"-overlay'>X</div></a>");
         $close.click(function(){
          jQuery("#"+overlayId).overlay().close();
         });
         $main.prepend($close);
       } else {
         $main.children("a.close").remove();
       }
       return $main;
     },
     _onClose: function _onClose(){
       jQuery("#"+this.options.dom.id).remove();
       var callbacks = this.removalCallbacks;
       if (!helper.undefOrNull(this.__resizeFunction)){
         jQuery(window).off('resize', this.__resizeFunction);
       }
       for (var i=0; i<this.removalCallbacks.length; i++){
         var cb = callbacks[i];
         cb(this);
       }
     },
     _onResize: function _onResize(){
       this.centerContent();
     },
     /*********************
      * 'PUBLIC'  Methods *
      *********************/
     enableAutoCenter: function enableAutoCenter(){
       var self = this;
       this.__resizeFunction = function(){ self._onResize(); };
       jQuery(window).on('resize', this.__resizeFunction);
     },
     disableAutoCenter: function disableAutoCenter(){
       jQuery(window).off('resize', this.__resizeFunction);
     },
     position: function position(){
       //NOTE: as this._instance.position(); would return incorrect values on Safari <= 9, we currently use the CSS values here
       //return this._instance.position();
       if (helper.undefOrNull(this._instance)){
         return { top: 0, left: 0 };
       }

       var top = parseInt(this._instance.css("top"));
       top = isNaN(top) ? 0 : top;
       var marginTop = parseInt(this._instance.css("marginTop"));
       marginTop = isNaN(marginTop) ? 0 : marginTop;
       var allTop = top+marginTop;

       var left = parseInt(this._instance.css("left"));
       left = isNaN(left) ? 0 : left;
       var marginLeft = parseInt(this._instance.css("marginLeft"));
       marginLeft = isNaN(marginLeft) ? 0 : marginLeft;
       var allLeft = left+marginLeft;

       var pos = {
         top: allTop,
         left: allLeft
       };

       return pos;
     },
     getLeftPos: function getLeftPos(){
       if (this.posLeftPx !== null){
         return this.posLeftPx;
       } else if (this.content instanceof jQuery){
         var middle = jQuery(window).width()/2;
         var contentWidth = this.content.width()/2;
         var left = middle - contentWidth;
         return left;
       } else {
         return 0;
       }
     },
     setLeftPos: function setLeftPos(leftPos){
       if (!helper.undefOrNull(leftPos) && !isNaN(leftPos)){
         this.posLeftPx = leftPos;
         jQuery(this._instance).css({ left: leftPos+'px' });
         if (isNaN(leftPos) && typeof leftPos == "string" && !leftPos.endsWith('px')){
           throw "leftPos is not a valid value: " + leftPos;
         }
       } else {
         logger.warn("leftPos was set to a non numeric value; Enabling autocenter");
         this.enableAutoCenter();
       }
     },
     centerContent: function(){
       var middle = jQuery(window).width()/2;
       var contentWidth = this.content.width();
       var left = middle - contentWidth/2;
       this.setLeftPos(left);
       return this;
     },
     show: function show(){
       var $el = this._getGeneratedDom();
       var self = this;
       jQuery(this.options.dom.parentSelector).prepend($el);
       this._instance = $el.overlay({
     		mask: this.options.mask,
     		left: this.getLeftPos()+"px",
     		load: true,
        fixed: this.options.dom.fixed,
        closeOnClick: this.options.dom.closeOnClick,
     		onClose: function() { self._onClose(); },
        close: $el.children("#close-"+this.options.dom.id+"-overlay").parent()
     	 });
       if (helper.undefOrNull(this.posLeftPx)){
         this.centerContent();
       }
       return this;
     },
     remove: function remove(){
       if (!helper.undefOrNull(this._instance)){
         jQuery("#"+this.options.dom.id).overlay().close();
       }
     },
     setContent: function setContent(newContent){
       if (!helper.undefOrNull(newContent) && typeof newContent == "string"){
         throw "Strings as content are not allowed; Please pass a DOM Element (native or jQuery)!";
       }
       this.content = jQuery(newContent);
       /*
       if (helper.undefOrNull(this.posLeftPx)){
         this.getLeftPos(_getGeneratedDom());
       }
       */
       return this;
     },
     getContent: function getContent(){
       return this.content;
     },
     resizeContent: function resizeContent(newWidth, newHeight, doCenter){
       if (!helper.undefOrNull(newWidth)){
         jQuery(this._instance).css({ width: newWidth+'px' });
         jQuery(this.content).css({ width: newWidth+'px' });
       }
       if (!helper.undefOrNull(newHeight)){
         jQuery(this._instance).css({ height: newHeight+'px' });
         jQuery(this.content).css({ height: newHeight+'px' });
       }
       if (!helper.undefOrNull(doCenter)){
         centerContent();
       }
     },
     setRemovalCallback: function setRemovalCallback(callback){
       if (typeof callback !== "function"){
         throw "given Callback is not a function";
       }
       this.removalCallbacks.length = 0;
       this.addRemovalCallback(callback);
       return this;
     },
     addRemovalCallback: function addRemovalCallback(callback){
       if (typeof callback !== "function"){
         throw "given Callback is not a function";
       }
       this.removalCallbacks.push(callback);
       return this;
     },
     removeRemovalCallback: function removeRemovalCallback(callback){
       var idx = this.removalCallbacks.indexOf(callback);
       this.removalCallbacks.splice(idx, 1);
       return this;
     },
     modifyOptionsWith: function modifyOptionsWith(optionsObject){
       if (typeof optionsObject == "undefined" || optionsObject === null){
         return;
       }
       jQuery.extend( true, this.options, optionsObject );
       return this;
     },
     height: function height(){
       return this._instance.height();
     },
     width: function width(){
       return this._instance.width();
     },
     getCloseButton: function getCloseButton(){
       if (this.options.dom.showClose){
         return this._instance.find("#close-"+this.options.dom.id+"-overlay").parent();
       }
       return null;
     }
   };
}).call(this);



//////////////////
// WEBPACK FOOTER
// ./src/Overlay/main.js
// module id = 10
// module chunks = 0